import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet'
import { useTheme } from '@mui/material'
import 'leaflet/dist/leaflet.css'
import geographic from '../../data/geographic.json'

function InstallationsMap() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  // Calculate marker size based on measurement count
  const getRadius = (count) => {
    if (count >= 50) return 20
    if (count >= 20) return 15
    if (count >= 10) return 12
    return 8
  }

  // Color based on region
  const getColor = (region) => {
    const colors = {
      'Northeast': '#A0CE4E',
      'Southeast': '#64b5f6',
      'Southwest': '#ff9800',
      'Midwest': '#ab47bc',
      'Mountain': '#26a69a',
      'International': '#ef5350'
    }
    return colors[region] || '#A0CE4E'
  }

  // Center on world view to show all installations (US + international)
  const center = [25, -40]

  return (
    <MapContainer
      center={center}
      zoom={2}
      style={{ height: '100%', width: '100%', borderRadius: '8px' }}
      scrollWheelZoom={false}
      minZoom={1}
      maxZoom={10}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {geographic.map((loc, index) => (
        <CircleMarker
          key={index}
          center={[loc.lat, loc.lng]}
          radius={getRadius(loc.measurements)}
          fillColor={getColor(loc.region)}
          color="#fff"
          weight={2}
          opacity={1}
          fillOpacity={0.7}
        >
          <Popup>
            <div style={{ minWidth: 150 }}>
              <strong>{loc.location}</strong>
              {loc.state && <span> ({loc.state})</span>}
              <br />
              <span style={{ color: '#666' }}>{loc.region}</span>
              <br />
              <strong style={{ color: isDark ? '#A0CE4E' : '#1a1a1a' }}>
                {loc.measurements} measurements
              </strong>
            </div>
          </Popup>
        </CircleMarker>
      ))}
    </MapContainer>
  )
}

export default InstallationsMap
